import Vue from "vue";
import Spinner from "~/components/includes/Spinner.vue";

// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Spinner", Spinner);
